import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeader: {
		id: 'admin-pages-screens-page.screens-page-description.page-header',
		defaultMessage: 'Screens',
		description: 'Header of Screens Page',
	},
	screensDescription: {
		id: 'admin-pages-screens-page.screens-page-description.screens-description',
		defaultMessage:
			'A screen is an arrangement of fields that are displayed when the issue is created, edited or transitioned through workflow.',
		description: 'Description for screens page',
	},
	screensDescriptionFirstBulletPoint: {
		id: 'admin-pages-screens-page.screens-page-description.screens-description-first-bullet-point',
		defaultMessage:
			'To choose screens that are displayed when issues are created or edited please map the screens to issue operations using {screenSchemesLink}.',
		description: 'Description for screens page',
	},
	screensDescriptionSecondBulletPoint: {
		id: 'admin-pages-screens-page.screens-page-description.screens-description-second-bullet-point',
		defaultMessage:
			'To select which screen is displayed for a particular workflow transition, please select the {workflowLink} the transition belongs to and edit it.',
		description: 'Description for screens page',
	},
	screensNote: {
		id: 'admin-pages-screens-page.screens-page-description.screens-note',
		defaultMessage:
			'Note: it is only possible to delete a screen if it is not part of a Screen Scheme and is not used in any workflows.',
		description: 'Description for screens page',
	},
	screenSchemes: {
		id: 'admin-pages-screens-page.screens-page-description.screen-schemes',
		defaultMessage: 'Screen Schemes',
		description: 'screen schemes text',
	},
	workflow: {
		id: 'admin-pages-screens-page.screens-page-description.workflow',
		defaultMessage: 'workflow',
		description: 'workflow text',
	},
});
